import { filter, map } from 'rxjs/operators';
import { ofType } from 'redux-observable';
// ---- external imports -----

import {
	uiSelectors,
	turnSelectors
} from '~/store';
import { FINANCIAL_STATEMENTS_DISTRIBUTE_PROFIT } from '~/store/financial-statements/actionTypes';
// ---- internal imports ----

import { updateGeneralLogAfterProfitDistribution } from '../actions';
// ---- parent imports ----


const onDistributedProfitSubmissionEpic = (action$, state$) => action$.pipe(
	ofType(
		FINANCIAL_STATEMENTS_DISTRIBUTE_PROFIT,
	),
	filter(() => (!uiSelectors.isPlayerHealthBarLocked(state$.value))),
	map((action) => {
		const { amount } = action;
		const turnDate = turnSelectors.getTurnDate(state$.value);
		const date = new Date(turnDate);

		return updateGeneralLogAfterProfitDistribution(date, amount);
	})
);

export default onDistributedProfitSubmissionEpic;
